module.exports = __webpack_public_path__ + "static/profile-eric-griego-bb6afd38d2d81ab6a09d6d6ce1339fea.png";